"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokensToCurrency = exports.currencyToTokens = void 0;
var web3_utils_1 = require("web3-utils");
var launchpadConstants_1 = require("../../launchpadConstants");
var decimals = (0, web3_utils_1.toBN)(1e12);
var currencyToTokens = function (props) { return convert("cur2Tok", props); };
exports.currencyToTokens = currencyToTokens;
var tokensToCurrency = function (props) { return convert("tok2Cur", props); };
exports.tokensToCurrency = tokensToCurrency;
function convert(direction, props) {
    var value = props.value, rate = props.rate;
    if (!value || value.eq(launchpadConstants_1.ZERO_BN) || rate === 0) {
        return launchpadConstants_1.ZERO_BN;
    }
    var rateBN = (0, web3_utils_1.toBN)(Math.round(rate * 1e12));
    try {
        return direction === "cur2Tok"
            ? value.mul(rateBN).div(decimals)
            : value.mul(decimals).div(rateBN);
    }
    catch (e) {
        console.error("currencyToTokens failed", props);
        return launchpadConstants_1.ZERO_BN;
    }
}
